module.exports = __webpack_public_path__ + "static/img/holography.0aeeda9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Home/holography.png
// module id = SJDv
// module chunks = 7